import React from 'react';
import styled from 'styled-components';

const origineHeight = 554;
const origineWidth = 554;

const Wrapper = styled.div`
  font-size: 60px;
  text-align: center;
  max-height: 100%;
  font-family: var(--theme-typography-primary-font);
  font-weight: 700;
  color: var(--theme-background-contrast-text-color);
  position: relative;
`;

const WrapperScale = styled.div`
  height: ${origineHeight}px;
  width: ${origineWidth}px;
  position: absolute;
`;

const Image = styled.div`
  background: var(--sticker-like);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 100%;
  padding-bottom: 100px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1.62;
  div {
    width: 76%;
  }
`;

type Props = {
  label: string;
  scale: number;
};

const Like = ({ label, scale }: Props) => {
  const height = origineHeight * scale;
  const width = origineWidth * scale;

  return (
    <Wrapper style={{ height, width }}>
      <WrapperScale style={{ transform: `scale(${scale})`, transformOrigin: '0 0' }}>
        <Image>
          <div>{label}</div>
        </Image>
      </WrapperScale>
    </Wrapper>
  );
};

export default Like;
